'use client';

import type { FC } from 'react';

import type { PromotionWideBannerItemType } from '@weberus/shared-types';
import Image from 'next/image';

interface PromotionWideBannerItemProps extends PromotionWideBannerItemType {
  onClick?: (ev: React.MouseEvent<HTMLAnchorElement>) => void;
  isPriority?: boolean;
  width?: number;
  height?: number;
}

export const PromotionWideBannerItem: FC<PromotionWideBannerItemProps> = ({
  image,
  title,
  action,
  onClick,
  isPriority,
}) => {
  return (
    <a className="w-full block" href={action.web} onClick={(ev) => onClick?.(ev)}>
      {/*
       aspect ratio 처럼 사용하고 싶으면 다음과 같이 설정하라고 공식문서에서 제안함
       @see @{link https://nextjs.org/docs/pages/api-reference/components/image#responsive-image-with-aspect-ratio}
      */}
      <Image
        alt={title}
        className="object-contain w-full h-auto rounded-12 pc:rounded-16"
        height={0}
        priority={isPriority}
        src={image.url}
        unoptimized
        width={0}
      />
    </a>
  );
};
